import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=07fd1e6e&"
import script from "./serve.vue?vue&type=script&lang=js&"
export * from "./serve.vue?vue&type=script&lang=js&"
import style0 from "./serve.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports